/* eslint-disable max-len */
import React, { FC, Fragment, useState } from 'react'
import { decode } from 'html-entities'

import { Box, Button, Typography } from '@material-ui/core'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp'
import ThumbUpOutlinedIcon from '@material-ui/icons/ThumbUpOutlined'
import ThumbDownOutlinedIcon from '@material-ui/icons/ThumbDownOutlined'
import ThumbUpIcon from '@material-ui/icons/ThumbUp'
import ThumbDownIcon from '@material-ui/icons/ThumbDown'

import { useQuestionsListStyles } from '../../questions-list/questions-list.styles'
import { useMutationLike } from '../queries'
import { useTranslation } from '@plandi/common'

type QuestionItemProps = {
  id: number
  partition?: string
  question: string
  title: string
  useful_no?: number
  useful_user?: boolean
  useful_yes?: number
  index: number
  page: number
}

export const QuestionItem: FC<QuestionItemProps> = (props) => {
  const [showDescription, setShowDescription] = useState(false)
  const [hover, setHover] = useState(false)
  const [hoverBtnYes, setHoverBtnYes] = useState(false)
  const [hoverBtnNo, setHoverBtnNo] = useState(false)
  const { data: translation } = useTranslation()

  const classes = useQuestionsListStyles()

  const mutation = useMutationLike()

  const handleLike = (answer: string) => {
    mutation.mutate({ id: props.id, value: answer === 'yes' ? 1 : 0 })
  }

  const desc = decode(props.question)

  const totalFaqs = (currentPage: number) => {
    const total = props.index + 1 + 15 * (currentPage - 1)
    return total
  }

  return (
    <div key={props.id} className={classes.question}>
      <Box
        onMouseOver={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        className={classes.questionTitleBlock}
        onClick={() => setShowDescription((prev) => !prev)}
      >
        <div style={{ display: 'flex', marginRight: 20 }}>
          <Typography
            className={classes.questionNumber}
            style={{ color: hover ? '#2E68BD' : '' }}
          >{`${totalFaqs(props.page)}.`}</Typography>
          <Typography
            className={classes.questionTitle}
            style={{ color: hover ? '#2E68BD' : '' }}
          >
            {props.title}
          </Typography>
        </div>
        {showDescription ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
      </Box>
      {showDescription && (
        <Fragment>
          <div
            className={classes.description}
            dangerouslySetInnerHTML={{ __html: decode(desc) }}
          />
          <div className={classes.likes}>
            <Typography
              className={classes.likesTitle}
              style={{
                color:
                  props.useful_no > 0 || props.useful_yes > 0
                    ? 'rgba(0, 0, 0, 0.26)'
                    : null
              }}
            >
              {translation?.['useful-article']}
            </Typography>
            <Button
              variant="text"
              className={classes.likesBtn}
              onMouseOver={() => setHoverBtnYes(true)}
              onMouseLeave={() => setHoverBtnYes(false)}
              disabled={
                mutation.isLoading ||
                mutation.isSuccess ||
                props.useful_no > 0 ||
                props.useful_yes > 0
              }
              onClick={() => {
                handleLike('yes')
              }}
              startIcon={
                props.useful_yes > 0 || hoverBtnYes ? (
                  <ThumbUpIcon />
                ) : (
                  <ThumbUpOutlinedIcon />
                )
              }
            >
              {translation?.yes?.toLowerCase()}
            </Button>
            <Button
              variant="text"
              className={classes.likesBtn}
              onMouseOver={() => setHoverBtnNo(true)}
              onMouseLeave={() => setHoverBtnNo(false)}
              disabled={
                mutation.isLoading ||
                mutation.isSuccess ||
                props.useful_no > 0 ||
                props.useful_yes > 0
              }
              onClick={() => {
                handleLike('no')
              }}
              startIcon={
                props.useful_no > 0 || hoverBtnNo ? (
                  <ThumbDownIcon />
                ) : (
                  <ThumbDownOutlinedIcon />
                )
              }
            >
              {translation?.no}
            </Button>
          </div>
        </Fragment>
      )}
    </div>
  )
}
